export default __webpack_public_path__ + "static/media/en_US.b54777ca.svg";